import { useListUsersAdministration } from '@/modules/api/codegen';

import { UserAdministrationType } from '../../constants';
import { useUserAdministrationStore } from '../../hooks';
import { UserAdministrationFilters } from '../UserAdministrationFilters';
import { UserAdministrationTable } from '../UserAdministrationTable';
import { usePeopleTableColumns } from './hooks/usePeopleTableColumns';

export const PeopleTabContent = () => {
    const columns = usePeopleTableColumns();

    const { filters, pagination, sort } = useUserAdministrationStore();
    const usersQuery = useListUsersAdministration({ ...filters.users, ...pagination.users, ...sort.users });

    return (
        <>
            <UserAdministrationFilters type={UserAdministrationType.Users} query={usersQuery} />
            <UserAdministrationTable type={UserAdministrationType.Users} query={usersQuery} columns={columns} />
        </>
    );
};
